import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, firstValueFrom } from 'rxjs';
import { AccountDto } from 'src/app/dtos/dtos';
import { AccountService } from 'src/app/services/account.service';
// import { AccountDto } from '../../dtos/dtos';
// import { AccountService } from '../../services/account.service';

@Component({
  selector: 'je-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AccountsComponent implements OnInit, OnDestroy {
  year = null;
  readonly years = [2018, 2017, 2019, 2020, 2021, 2022, 2023].sort(
    (a, b) => b - a,
  );
  subs: Subscription[] = [];
  accounts: AccountDto[];

  displayedColumns: string[] = [
    'id',
    'permaId',
    'name',
    'email',
    'emailsSent',
    'actions',
  ];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  datasource = new MatTableDataSource();

  constructor(
    public accountService: AccountService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    this.load(this.year);
  }

  load(year?: number) {
    console.log(year);

    firstValueFrom(this.accountService.getAll(year)).then((resp) => {
      this.accounts = resp;
      this.datasource.data = resp;
      this.datasource.sort = this.sort;
    });
  }

  ngOnDestroy(): void {
    this.subs.forEach((e) => e.unsubscribe());
  }
}
